import { Card, CardContent, CardMedia, Chip, Typography, Box, alpha } from "@mui/material";
import { Business as BusinessIcon, LocationOn as LocationIcon } from "@mui/icons-material";
import { ApartmentComplex } from "../../../types/propertyInventory/ApartmentComplex";
import { usePropertyInventory } from "../../../hooks/usePropertyInventory";
import { useEffect, useState } from "react";
import { ApartmentDto } from "../../../types/propertyInventory/Apartment";

interface PropertyComplexCardProps {
  complex: ApartmentComplex;
  onClick: () => void;
}

export const PropertyComplexCard = ({ complex, onClick }: PropertyComplexCardProps) => {
  const { getApartmentsByComplexId } = usePropertyInventory();
  const [apartmentsByComplex, setApartmentsByComplex] = useState<ApartmentDto[]>([]);

  useEffect(() => {
    if (complex.id) {
      (async () => {
        const response = await getApartmentsByComplexId(complex.id);
        setApartmentsByComplex(response);
      })();
    }
  }, [complex.id, getApartmentsByComplexId]);

  const totalApartments = apartmentsByComplex?.length || 0;
  const availableApartments = apartmentsByComplex?.filter(apartment => apartment.status === 1).length || 0;

  return (
    <Card 
      onClick={onClick}
      sx={{
        height: '100%',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: alpha('#E0E0E0', 0.3),
        '&:hover': {
          transform: 'translateY(-8px) scale(1.02)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
          borderColor: alpha('#4DB6AC', 0.4),
        }
      }}
    >
      <CardMedia
        component="img"
        height="200"
        image={complex.multimedia.length > 0 ? complex.multimedia[0] : '/images/default-complex.jpg'}
        alt={complex.name}
        sx={{
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'scale(1.05)',
          }
        }}
      />
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BusinessIcon sx={{ color: '#4DB6AC', mr: 1 }} />
          <Typography variant="h6" fontWeight="bold" color="#2E7D7A">
            {complex.name}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <LocationIcon sx={{ color: '#80CBC4', mr: 1, fontSize: 18 }} />
          <Typography variant="body2" color="text.secondary">
            {complex.location}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip 
            label={`${totalApartments} unidades`}
            size="small"
            sx={{ 
              backgroundColor: alpha('#4DB6AC', 0.1),
              color: '#2E7D7A',
              fontWeight: 'medium'
            }}
          />
          <Chip 
            label={`${availableApartments} disponibles`}
            size="small"
            sx={{ 
              backgroundColor: alpha('#66BB6A', 0.1),
              color: '#388E3C',
              fontWeight: 'medium'
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};